module.exports = __webpack_public_path__ + "static/img/kepu.b8003ad.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/kepu.jpg
// module id = IB0x
// module chunks = 1